import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'FundValue',
    column_type: 'id',
  },
  created_at: {
    model_name: 'FundValue',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'FundValue',
    column_type: 'datetime',
  },
  value: {
    model_name: 'FundValue',
    column_type: 'decimal',
  },
  fund: {
    model_name: 'FundValue',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'fund',
      model_name: 'Fund',
      foreign_key: 'fund_id',
    },
  },
  fund_id: {
    model_name: 'FundValue',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'fund',
      model_name: 'Fund',
      foreign_key: 'fund_id',
    },
  },
  date: {
    model_name: 'FundValue',
    column_type: 'date',
  },
  accumulative_value: {
    model_name: 'FundValue',
    column_type: 'decimal',
  },
}

export const columnsExtend = (columns, filterColumnsExtend) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
